/* eslint-disable */
/* this file is generated by generateIcons script */

import React from 'react'
import BaseIcon from '../../BaseIcon'

export default class MicrosoftIcon extends BaseIcon {
  getChildren = () => [
    <g>
      <path fill='#F1511B' d="M22.9,22.9H2V2h20.9V22.9z"/>
      <path fill='#80CC28' d="M46,22.9H25.1V2H46L46,22.9L46,22.9z"/>
      <path fill='#00ADEF' d="M22.9,46H2V25.1h20.9V46z"/>
      <path fill='#FBBC09' d="M46,46H25.1V25.1H46L46,46L46,46z"/>
    </g>
  ]
  getViewBox = () => '0 0 48 48'
}
